/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

import { EmptyIcon } from '@src/components/common/icons/EmptyIcon';

const StyledEmptyIcon = styled(EmptyIcon)`
	fill: #F5F5F7;
`;

const Content = styled.div`
	margin-top: 60px;
	flex-direction: column;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Text = styled.div`
	font-weight: 300;
	font-size: 16px;
	margin-top: 12px;
	color: #676767;
	text-align: center;

	&.preLine {
		white-space: pre-line;
	}
`;

const EmptyInfo = ({ className, textClassName, text, icon }: { className?: string; textClassName?: string, text: string; icon?: JSX.Element }):JSX.Element => (
	<Content className={`empty-info ${className}`}>
		{icon || <StyledEmptyIcon />}
		<Text className={textClassName}>{text}</Text>
	</Content>
);

export default EmptyInfo;
